module.exports = __webpack_public_path__ + "static/media/slide01.1e78f02e.jpg";